import { apiClient } from "./client";
import config from "@/lib/config";
import { ApiResponse, LoginRequest, AuthResponse } from "@/types/api";
import { User } from "@/types/user";

export class AuthService {
  async adminLogin(data: LoginRequest): Promise<ApiResponse<AuthResponse>> {
    const response = await apiClient.post<AuthResponse>(
      config.endpoints.auth.adminLogin,
      data,
    );

    return response;
  }

  async logout(): Promise<ApiResponse> {
    const response = await apiClient.post(config.endpoints.auth.logout);

    return response;
  }

  async refreshToken(): Promise<ApiResponse> {
    return apiClient.post(config.endpoints.auth.refresh);
  }

  async getMe(): Promise<ApiResponse<User>> {
    return apiClient.get(config.endpoints.auth.me);
  }
}

export const authService = new AuthService();
